// packages/alpinejs/src/scheduler.js
var $8e5dcecbc0be3c0e$var$flushPending = false;
var $8e5dcecbc0be3c0e$var$flushing = false;
var $8e5dcecbc0be3c0e$var$queue = [];
var $8e5dcecbc0be3c0e$var$lastFlushedIndex = -1;
function $8e5dcecbc0be3c0e$var$scheduler(callback) {
    $8e5dcecbc0be3c0e$var$queueJob(callback);
}
function $8e5dcecbc0be3c0e$var$queueJob(job) {
    if (!$8e5dcecbc0be3c0e$var$queue.includes(job)) $8e5dcecbc0be3c0e$var$queue.push(job);
    $8e5dcecbc0be3c0e$var$queueFlush();
}
function $8e5dcecbc0be3c0e$var$dequeueJob(job) {
    let index = $8e5dcecbc0be3c0e$var$queue.indexOf(job);
    if (index !== -1 && index > $8e5dcecbc0be3c0e$var$lastFlushedIndex) $8e5dcecbc0be3c0e$var$queue.splice(index, 1);
}
function $8e5dcecbc0be3c0e$var$queueFlush() {
    if (!$8e5dcecbc0be3c0e$var$flushing && !$8e5dcecbc0be3c0e$var$flushPending) {
        $8e5dcecbc0be3c0e$var$flushPending = true;
        queueMicrotask($8e5dcecbc0be3c0e$var$flushJobs);
    }
}
function $8e5dcecbc0be3c0e$var$flushJobs() {
    $8e5dcecbc0be3c0e$var$flushPending = false;
    $8e5dcecbc0be3c0e$var$flushing = true;
    for(let i = 0; i < $8e5dcecbc0be3c0e$var$queue.length; i++){
        $8e5dcecbc0be3c0e$var$queue[i]();
        $8e5dcecbc0be3c0e$var$lastFlushedIndex = i;
    }
    $8e5dcecbc0be3c0e$var$queue.length = 0;
    $8e5dcecbc0be3c0e$var$lastFlushedIndex = -1;
    $8e5dcecbc0be3c0e$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $8e5dcecbc0be3c0e$var$reactive;
var $8e5dcecbc0be3c0e$var$effect;
var $8e5dcecbc0be3c0e$var$release;
var $8e5dcecbc0be3c0e$var$raw;
var $8e5dcecbc0be3c0e$var$shouldSchedule = true;
function $8e5dcecbc0be3c0e$var$disableEffectScheduling(callback) {
    $8e5dcecbc0be3c0e$var$shouldSchedule = false;
    callback();
    $8e5dcecbc0be3c0e$var$shouldSchedule = true;
}
function $8e5dcecbc0be3c0e$var$setReactivityEngine(engine) {
    $8e5dcecbc0be3c0e$var$reactive = engine.reactive;
    $8e5dcecbc0be3c0e$var$release = engine.release;
    $8e5dcecbc0be3c0e$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($8e5dcecbc0be3c0e$var$shouldSchedule) $8e5dcecbc0be3c0e$var$scheduler(task);
                else task();
            }
        });
    $8e5dcecbc0be3c0e$var$raw = engine.raw;
}
function $8e5dcecbc0be3c0e$var$overrideEffect(override) {
    $8e5dcecbc0be3c0e$var$effect = override;
}
function $8e5dcecbc0be3c0e$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $8e5dcecbc0be3c0e$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $8e5dcecbc0be3c0e$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
// packages/alpinejs/src/utils/dispatch.js
function $8e5dcecbc0be3c0e$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $8e5dcecbc0be3c0e$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$8e5dcecbc0be3c0e$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $8e5dcecbc0be3c0e$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $8e5dcecbc0be3c0e$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $8e5dcecbc0be3c0e$var$started = false;
function $8e5dcecbc0be3c0e$var$start() {
    if ($8e5dcecbc0be3c0e$var$started) $8e5dcecbc0be3c0e$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $8e5dcecbc0be3c0e$var$started = true;
    if (!document.body) $8e5dcecbc0be3c0e$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $8e5dcecbc0be3c0e$var$dispatch(document, "alpine:init");
    $8e5dcecbc0be3c0e$var$dispatch(document, "alpine:initializing");
    $8e5dcecbc0be3c0e$var$startObservingMutations();
    $8e5dcecbc0be3c0e$var$onElAdded((el)=>$8e5dcecbc0be3c0e$var$initTree(el, $8e5dcecbc0be3c0e$var$walk));
    $8e5dcecbc0be3c0e$var$onElRemoved((el)=>$8e5dcecbc0be3c0e$var$destroyTree(el));
    $8e5dcecbc0be3c0e$var$onAttributesAdded((el, attrs)=>{
        $8e5dcecbc0be3c0e$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$8e5dcecbc0be3c0e$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($8e5dcecbc0be3c0e$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $8e5dcecbc0be3c0e$var$initTree(el);
    });
    $8e5dcecbc0be3c0e$var$dispatch(document, "alpine:initialized");
}
var $8e5dcecbc0be3c0e$var$rootSelectorCallbacks = [];
var $8e5dcecbc0be3c0e$var$initSelectorCallbacks = [];
function $8e5dcecbc0be3c0e$var$rootSelectors() {
    return $8e5dcecbc0be3c0e$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $8e5dcecbc0be3c0e$var$allSelectors() {
    return $8e5dcecbc0be3c0e$var$rootSelectorCallbacks.concat($8e5dcecbc0be3c0e$var$initSelectorCallbacks).map((fn)=>fn());
}
function $8e5dcecbc0be3c0e$var$addRootSelector(selectorCallback) {
    $8e5dcecbc0be3c0e$var$rootSelectorCallbacks.push(selectorCallback);
}
function $8e5dcecbc0be3c0e$var$addInitSelector(selectorCallback) {
    $8e5dcecbc0be3c0e$var$initSelectorCallbacks.push(selectorCallback);
}
function $8e5dcecbc0be3c0e$var$closestRoot(el, includeInitSelectors = false) {
    return $8e5dcecbc0be3c0e$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $8e5dcecbc0be3c0e$var$allSelectors() : $8e5dcecbc0be3c0e$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $8e5dcecbc0be3c0e$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $8e5dcecbc0be3c0e$var$findClosest(el.parentElement, callback);
}
function $8e5dcecbc0be3c0e$var$isRoot(el) {
    return $8e5dcecbc0be3c0e$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $8e5dcecbc0be3c0e$var$initInterceptors = [];
function $8e5dcecbc0be3c0e$var$interceptInit(callback) {
    $8e5dcecbc0be3c0e$var$initInterceptors.push(callback);
}
function $8e5dcecbc0be3c0e$var$initTree(el, walker = $8e5dcecbc0be3c0e$var$walk, intercept = ()=>{}) {
    $8e5dcecbc0be3c0e$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $8e5dcecbc0be3c0e$var$initInterceptors.forEach((i)=>i(el2, skip));
            $8e5dcecbc0be3c0e$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $8e5dcecbc0be3c0e$var$destroyTree(root) {
    $8e5dcecbc0be3c0e$var$walk(root, (el)=>{
        $8e5dcecbc0be3c0e$var$cleanupAttributes(el);
        $8e5dcecbc0be3c0e$var$cleanupElement(el);
    });
}
// packages/alpinejs/src/mutation.js
var $8e5dcecbc0be3c0e$var$onAttributeAddeds = [];
var $8e5dcecbc0be3c0e$var$onElRemoveds = [];
var $8e5dcecbc0be3c0e$var$onElAddeds = [];
function $8e5dcecbc0be3c0e$var$onElAdded(callback) {
    $8e5dcecbc0be3c0e$var$onElAddeds.push(callback);
}
function $8e5dcecbc0be3c0e$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $8e5dcecbc0be3c0e$var$onElRemoveds.push(callback);
    }
}
function $8e5dcecbc0be3c0e$var$onAttributesAdded(callback) {
    $8e5dcecbc0be3c0e$var$onAttributeAddeds.push(callback);
}
function $8e5dcecbc0be3c0e$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $8e5dcecbc0be3c0e$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $8e5dcecbc0be3c0e$var$cleanupElement(el) {
    if (el._x_cleanups) while(el._x_cleanups.length)el._x_cleanups.pop()();
}
var $8e5dcecbc0be3c0e$var$observer = new MutationObserver($8e5dcecbc0be3c0e$var$onMutate);
var $8e5dcecbc0be3c0e$var$currentlyObserving = false;
function $8e5dcecbc0be3c0e$var$startObservingMutations() {
    $8e5dcecbc0be3c0e$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $8e5dcecbc0be3c0e$var$currentlyObserving = true;
}
function $8e5dcecbc0be3c0e$var$stopObservingMutations() {
    $8e5dcecbc0be3c0e$var$flushObserver();
    $8e5dcecbc0be3c0e$var$observer.disconnect();
    $8e5dcecbc0be3c0e$var$currentlyObserving = false;
}
var $8e5dcecbc0be3c0e$var$recordQueue = [];
var $8e5dcecbc0be3c0e$var$willProcessRecordQueue = false;
function $8e5dcecbc0be3c0e$var$flushObserver() {
    $8e5dcecbc0be3c0e$var$recordQueue = $8e5dcecbc0be3c0e$var$recordQueue.concat($8e5dcecbc0be3c0e$var$observer.takeRecords());
    if ($8e5dcecbc0be3c0e$var$recordQueue.length && !$8e5dcecbc0be3c0e$var$willProcessRecordQueue) {
        $8e5dcecbc0be3c0e$var$willProcessRecordQueue = true;
        queueMicrotask(()=>{
            $8e5dcecbc0be3c0e$var$processRecordQueue();
            $8e5dcecbc0be3c0e$var$willProcessRecordQueue = false;
        });
    }
}
function $8e5dcecbc0be3c0e$var$processRecordQueue() {
    $8e5dcecbc0be3c0e$var$onMutate($8e5dcecbc0be3c0e$var$recordQueue);
    $8e5dcecbc0be3c0e$var$recordQueue.length = 0;
}
function $8e5dcecbc0be3c0e$var$mutateDom(callback) {
    if (!$8e5dcecbc0be3c0e$var$currentlyObserving) return callback();
    $8e5dcecbc0be3c0e$var$stopObservingMutations();
    let result = callback();
    $8e5dcecbc0be3c0e$var$startObservingMutations();
    return result;
}
var $8e5dcecbc0be3c0e$var$isCollecting = false;
var $8e5dcecbc0be3c0e$var$deferredMutations = [];
function $8e5dcecbc0be3c0e$var$deferMutations() {
    $8e5dcecbc0be3c0e$var$isCollecting = true;
}
function $8e5dcecbc0be3c0e$var$flushAndStopDeferringMutations() {
    $8e5dcecbc0be3c0e$var$isCollecting = false;
    $8e5dcecbc0be3c0e$var$onMutate($8e5dcecbc0be3c0e$var$deferredMutations);
    $8e5dcecbc0be3c0e$var$deferredMutations = [];
}
function $8e5dcecbc0be3c0e$var$onMutate(mutations) {
    if ($8e5dcecbc0be3c0e$var$isCollecting) {
        $8e5dcecbc0be3c0e$var$deferredMutations = $8e5dcecbc0be3c0e$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = [];
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.push(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.push(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $8e5dcecbc0be3c0e$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $8e5dcecbc0be3c0e$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.includes(node)) continue;
        $8e5dcecbc0be3c0e$var$onElRemoveds.forEach((i)=>i(node));
        $8e5dcecbc0be3c0e$var$destroyTree(node);
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.includes(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $8e5dcecbc0be3c0e$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $8e5dcecbc0be3c0e$var$scope(node) {
    return $8e5dcecbc0be3c0e$var$mergeProxies($8e5dcecbc0be3c0e$var$closestDataStack(node));
}
function $8e5dcecbc0be3c0e$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$8e5dcecbc0be3c0e$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $8e5dcecbc0be3c0e$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $8e5dcecbc0be3c0e$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $8e5dcecbc0be3c0e$var$closestDataStack(node.parentNode);
}
function $8e5dcecbc0be3c0e$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $8e5dcecbc0be3c0e$var$mergeProxyTrap);
}
var $8e5dcecbc0be3c0e$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $8e5dcecbc0be3c0e$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return Reflect.set(target, name, value, thisProxy);
        return Reflect.set(target, name, value);
    }
};
function $8e5dcecbc0be3c0e$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $8e5dcecbc0be3c0e$var$initInterceptors2(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $8e5dcecbc0be3c0e$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$8e5dcecbc0be3c0e$var$get(data2, path), (value)=>$8e5dcecbc0be3c0e$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $8e5dcecbc0be3c0e$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $8e5dcecbc0be3c0e$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $8e5dcecbc0be3c0e$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $8e5dcecbc0be3c0e$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $8e5dcecbc0be3c0e$var$magics = {};
function $8e5dcecbc0be3c0e$var$magic(name, callback) {
    $8e5dcecbc0be3c0e$var$magics[name] = callback;
}
function $8e5dcecbc0be3c0e$var$injectMagics(obj, el) {
    Object.entries($8e5dcecbc0be3c0e$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $8e5dcecbc0be3c0e$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $8e5dcecbc0be3c0e$var$interceptor,
                    ...utilities
                };
                $8e5dcecbc0be3c0e$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $8e5dcecbc0be3c0e$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $8e5dcecbc0be3c0e$var$handleError(e, el, expression);
    }
}
function $8e5dcecbc0be3c0e$var$handleError(error2, el, expression) {
    Object.assign(error2, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $8e5dcecbc0be3c0e$var$shouldAutoEvaluateFunctions = true;
function $8e5dcecbc0be3c0e$var$dontAutoEvaluateFunctions(callback) {
    let cache = $8e5dcecbc0be3c0e$var$shouldAutoEvaluateFunctions;
    $8e5dcecbc0be3c0e$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $8e5dcecbc0be3c0e$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $8e5dcecbc0be3c0e$var$evaluate(el, expression, extras = {}) {
    let result;
    $8e5dcecbc0be3c0e$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $8e5dcecbc0be3c0e$var$evaluateLater(...args) {
    return $8e5dcecbc0be3c0e$var$theEvaluatorFunction(...args);
}
var $8e5dcecbc0be3c0e$var$theEvaluatorFunction = $8e5dcecbc0be3c0e$var$normalEvaluator;
function $8e5dcecbc0be3c0e$var$setEvaluator(newEvaluator) {
    $8e5dcecbc0be3c0e$var$theEvaluatorFunction = newEvaluator;
}
function $8e5dcecbc0be3c0e$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $8e5dcecbc0be3c0e$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$8e5dcecbc0be3c0e$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $8e5dcecbc0be3c0e$var$generateEvaluatorFromFunction(dataStack, expression) : $8e5dcecbc0be3c0e$var$generateEvaluatorFromString(dataStack, expression, el);
    return $8e5dcecbc0be3c0e$var$tryCatch.bind(null, el, expression, evaluator);
}
function $8e5dcecbc0be3c0e$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($8e5dcecbc0be3c0e$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $8e5dcecbc0be3c0e$var$runIfTypeOfFunction(receiver, result);
    };
}
var $8e5dcecbc0be3c0e$var$evaluatorMemo = {};
function $8e5dcecbc0be3c0e$var$generateFunctionFromString(expression, el) {
    if ($8e5dcecbc0be3c0e$var$evaluatorMemo[expression]) return $8e5dcecbc0be3c0e$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $8e5dcecbc0be3c0e$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $8e5dcecbc0be3c0e$var$evaluatorMemo[expression] = func;
    return func;
}
function $8e5dcecbc0be3c0e$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $8e5dcecbc0be3c0e$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $8e5dcecbc0be3c0e$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$8e5dcecbc0be3c0e$var$handleError(error2, el, expression));
            if (func.finished) {
                $8e5dcecbc0be3c0e$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $8e5dcecbc0be3c0e$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$8e5dcecbc0be3c0e$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $8e5dcecbc0be3c0e$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($8e5dcecbc0be3c0e$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$8e5dcecbc0be3c0e$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$8e5dcecbc0be3c0e$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $8e5dcecbc0be3c0e$var$prefixAsString = "x-";
function $8e5dcecbc0be3c0e$var$prefix(subject = "") {
    return $8e5dcecbc0be3c0e$var$prefixAsString + subject;
}
function $8e5dcecbc0be3c0e$var$setPrefix(newPrefix) {
    $8e5dcecbc0be3c0e$var$prefixAsString = newPrefix;
}
var $8e5dcecbc0be3c0e$var$directiveHandlers = {};
function $8e5dcecbc0be3c0e$var$directive(name, callback) {
    $8e5dcecbc0be3c0e$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$8e5dcecbc0be3c0e$var$directiveHandlers[directive2]) {
                console.warn("Cannot find directive `${directive}`. `${name}` will use the default order of execution");
                return;
            }
            const pos = $8e5dcecbc0be3c0e$var$directiveOrder.indexOf(directive2);
            $8e5dcecbc0be3c0e$var$directiveOrder.splice(pos >= 0 ? pos : $8e5dcecbc0be3c0e$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $8e5dcecbc0be3c0e$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $8e5dcecbc0be3c0e$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($8e5dcecbc0be3c0e$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($8e5dcecbc0be3c0e$var$outNonAlpineAttributes).map($8e5dcecbc0be3c0e$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($8e5dcecbc0be3c0e$var$byPriority);
    return directives2.map((directive2)=>{
        return $8e5dcecbc0be3c0e$var$getDirectiveHandler(el, directive2);
    });
}
function $8e5dcecbc0be3c0e$var$attributesOnly(attributes) {
    return Array.from(attributes).map($8e5dcecbc0be3c0e$var$toTransformedAttributes()).filter((attr)=>!$8e5dcecbc0be3c0e$var$outNonAlpineAttributes(attr));
}
var $8e5dcecbc0be3c0e$var$isDeferringHandlers = false;
var $8e5dcecbc0be3c0e$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $8e5dcecbc0be3c0e$var$currentHandlerStackKey = Symbol();
function $8e5dcecbc0be3c0e$var$deferHandlingDirectives(callback) {
    $8e5dcecbc0be3c0e$var$isDeferringHandlers = true;
    let key = Symbol();
    $8e5dcecbc0be3c0e$var$currentHandlerStackKey = key;
    $8e5dcecbc0be3c0e$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($8e5dcecbc0be3c0e$var$directiveHandlerStacks.get(key).length)$8e5dcecbc0be3c0e$var$directiveHandlerStacks.get(key).shift()();
        $8e5dcecbc0be3c0e$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $8e5dcecbc0be3c0e$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $8e5dcecbc0be3c0e$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $8e5dcecbc0be3c0e$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $8e5dcecbc0be3c0e$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $8e5dcecbc0be3c0e$var$evaluateLater.bind($8e5dcecbc0be3c0e$var$evaluateLater, el),
        evaluate: $8e5dcecbc0be3c0e$var$evaluate.bind($8e5dcecbc0be3c0e$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $8e5dcecbc0be3c0e$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $8e5dcecbc0be3c0e$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $8e5dcecbc0be3c0e$var$getElementBoundUtilities(el);
    $8e5dcecbc0be3c0e$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $8e5dcecbc0be3c0e$var$isDeferringHandlers ? $8e5dcecbc0be3c0e$var$directiveHandlerStacks.get($8e5dcecbc0be3c0e$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $8e5dcecbc0be3c0e$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $8e5dcecbc0be3c0e$var$into = (i)=>i;
function $8e5dcecbc0be3c0e$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $8e5dcecbc0be3c0e$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $8e5dcecbc0be3c0e$var$attributeTransformers = [];
function $8e5dcecbc0be3c0e$var$mapAttributes(callback) {
    $8e5dcecbc0be3c0e$var$attributeTransformers.push(callback);
}
function $8e5dcecbc0be3c0e$var$outNonAlpineAttributes({ name: name }) {
    return $8e5dcecbc0be3c0e$var$alpineAttributeRegex().test(name);
}
var $8e5dcecbc0be3c0e$var$alpineAttributeRegex = ()=>new RegExp(`^${$8e5dcecbc0be3c0e$var$prefixAsString}([^:^.]+)\\b`);
function $8e5dcecbc0be3c0e$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($8e5dcecbc0be3c0e$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $8e5dcecbc0be3c0e$var$DEFAULT = "DEFAULT";
var $8e5dcecbc0be3c0e$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $8e5dcecbc0be3c0e$var$DEFAULT,
    "teleport"
];
function $8e5dcecbc0be3c0e$var$byPriority(a, b) {
    let typeA = $8e5dcecbc0be3c0e$var$directiveOrder.indexOf(a.type) === -1 ? $8e5dcecbc0be3c0e$var$DEFAULT : a.type;
    let typeB = $8e5dcecbc0be3c0e$var$directiveOrder.indexOf(b.type) === -1 ? $8e5dcecbc0be3c0e$var$DEFAULT : b.type;
    return $8e5dcecbc0be3c0e$var$directiveOrder.indexOf(typeA) - $8e5dcecbc0be3c0e$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/nextTick.js
var $8e5dcecbc0be3c0e$var$tickStack = [];
var $8e5dcecbc0be3c0e$var$isHolding = false;
function $8e5dcecbc0be3c0e$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $8e5dcecbc0be3c0e$var$isHolding || setTimeout(()=>{
            $8e5dcecbc0be3c0e$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $8e5dcecbc0be3c0e$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $8e5dcecbc0be3c0e$var$releaseNextTicks() {
    $8e5dcecbc0be3c0e$var$isHolding = false;
    while($8e5dcecbc0be3c0e$var$tickStack.length)$8e5dcecbc0be3c0e$var$tickStack.shift()();
}
function $8e5dcecbc0be3c0e$var$holdNextTicks() {
    $8e5dcecbc0be3c0e$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $8e5dcecbc0be3c0e$var$setClasses(el, value) {
    if (Array.isArray(value)) return $8e5dcecbc0be3c0e$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $8e5dcecbc0be3c0e$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $8e5dcecbc0be3c0e$var$setClasses(el, value());
    return $8e5dcecbc0be3c0e$var$setClassesFromString(el, value);
}
function $8e5dcecbc0be3c0e$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $8e5dcecbc0be3c0e$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $8e5dcecbc0be3c0e$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $8e5dcecbc0be3c0e$var$setStylesFromObject(el, value);
    return $8e5dcecbc0be3c0e$var$setStylesFromString(el, value);
}
function $8e5dcecbc0be3c0e$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $8e5dcecbc0be3c0e$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $8e5dcecbc0be3c0e$var$setStyles(el, previousStyles);
    };
}
function $8e5dcecbc0be3c0e$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $8e5dcecbc0be3c0e$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $8e5dcecbc0be3c0e$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$8e5dcecbc0be3c0e$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $8e5dcecbc0be3c0e$var$registerTransitionsFromHelper(el, modifiers, value);
    else $8e5dcecbc0be3c0e$var$registerTransitionsFromClassString(el, expression, value);
});
function $8e5dcecbc0be3c0e$var$registerTransitionsFromClassString(el, classString, stage) {
    $8e5dcecbc0be3c0e$var$registerTransitionObject(el, $8e5dcecbc0be3c0e$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $8e5dcecbc0be3c0e$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $8e5dcecbc0be3c0e$var$registerTransitionObject(el, $8e5dcecbc0be3c0e$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $8e5dcecbc0be3c0e$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $8e5dcecbc0be3c0e$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $8e5dcecbc0be3c0e$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $8e5dcecbc0be3c0e$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $8e5dcecbc0be3c0e$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $8e5dcecbc0be3c0e$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $8e5dcecbc0be3c0e$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $8e5dcecbc0be3c0e$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $8e5dcecbc0be3c0e$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $8e5dcecbc0be3c0e$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $8e5dcecbc0be3c0e$var$closestHide(parent);
}
function $8e5dcecbc0be3c0e$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $8e5dcecbc0be3c0e$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $8e5dcecbc0be3c0e$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $8e5dcecbc0be3c0e$var$once(()=>{
        $8e5dcecbc0be3c0e$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $8e5dcecbc0be3c0e$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $8e5dcecbc0be3c0e$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $8e5dcecbc0be3c0e$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $8e5dcecbc0be3c0e$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $8e5dcecbc0be3c0e$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $8e5dcecbc0be3c0e$var$mutateDom(()=>{
                stages.end();
            });
            $8e5dcecbc0be3c0e$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $8e5dcecbc0be3c0e$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $8e5dcecbc0be3c0e$var$isCloning = false;
function $8e5dcecbc0be3c0e$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$8e5dcecbc0be3c0e$var$isCloning ? fallback(...args) : callback(...args);
}
function $8e5dcecbc0be3c0e$var$onlyDuringClone(callback) {
    return (...args)=>$8e5dcecbc0be3c0e$var$isCloning && callback(...args);
}
var $8e5dcecbc0be3c0e$var$interceptors = [];
function $8e5dcecbc0be3c0e$var$interceptClone(callback) {
    $8e5dcecbc0be3c0e$var$interceptors.push(callback);
}
function $8e5dcecbc0be3c0e$var$cloneNode(from, to) {
    $8e5dcecbc0be3c0e$var$interceptors.forEach((i)=>i(from, to));
    $8e5dcecbc0be3c0e$var$isCloning = true;
    $8e5dcecbc0be3c0e$var$dontRegisterReactiveSideEffects(()=>{
        $8e5dcecbc0be3c0e$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $8e5dcecbc0be3c0e$var$isCloning = false;
}
var $8e5dcecbc0be3c0e$var$isCloningLegacy = false;
function $8e5dcecbc0be3c0e$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $8e5dcecbc0be3c0e$var$isCloning = true;
    $8e5dcecbc0be3c0e$var$isCloningLegacy = true;
    $8e5dcecbc0be3c0e$var$dontRegisterReactiveSideEffects(()=>{
        $8e5dcecbc0be3c0e$var$cloneTree(newEl);
    });
    $8e5dcecbc0be3c0e$var$isCloning = false;
    $8e5dcecbc0be3c0e$var$isCloningLegacy = false;
}
function $8e5dcecbc0be3c0e$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $8e5dcecbc0be3c0e$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $8e5dcecbc0be3c0e$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $8e5dcecbc0be3c0e$var$initTree(el, shallowWalker);
}
function $8e5dcecbc0be3c0e$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $8e5dcecbc0be3c0e$var$effect;
    $8e5dcecbc0be3c0e$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $8e5dcecbc0be3c0e$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $8e5dcecbc0be3c0e$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $8e5dcecbc0be3c0e$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $8e5dcecbc0be3c0e$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $8e5dcecbc0be3c0e$var$camelCase(name) : name;
    switch(name){
        case "value":
            $8e5dcecbc0be3c0e$var$bindInputValue(el, value);
            break;
        case "style":
            $8e5dcecbc0be3c0e$var$bindStyles(el, value);
            break;
        case "class":
            $8e5dcecbc0be3c0e$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $8e5dcecbc0be3c0e$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $8e5dcecbc0be3c0e$var$bindAttribute(el, name, value);
            break;
    }
}
function $8e5dcecbc0be3c0e$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $8e5dcecbc0be3c0e$var$safeParseBoolean(el.value) === value;
            else el.checked = $8e5dcecbc0be3c0e$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$8e5dcecbc0be3c0e$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $8e5dcecbc0be3c0e$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $8e5dcecbc0be3c0e$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $8e5dcecbc0be3c0e$var$setClasses(el, value);
}
function $8e5dcecbc0be3c0e$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $8e5dcecbc0be3c0e$var$setStyles(el, value);
}
function $8e5dcecbc0be3c0e$var$bindAttributeAndProperty(el, name, value) {
    $8e5dcecbc0be3c0e$var$bindAttribute(el, name, value);
    $8e5dcecbc0be3c0e$var$setPropertyIfChanged(el, name, value);
}
function $8e5dcecbc0be3c0e$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $8e5dcecbc0be3c0e$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($8e5dcecbc0be3c0e$var$isBooleanAttr(name)) value = name;
        $8e5dcecbc0be3c0e$var$setIfChanged(el, name, value);
    }
}
function $8e5dcecbc0be3c0e$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $8e5dcecbc0be3c0e$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $8e5dcecbc0be3c0e$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $8e5dcecbc0be3c0e$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $8e5dcecbc0be3c0e$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $8e5dcecbc0be3c0e$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
function $8e5dcecbc0be3c0e$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "hidden",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $8e5dcecbc0be3c0e$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $8e5dcecbc0be3c0e$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $8e5dcecbc0be3c0e$var$getAttributeBinding(el, name, fallback);
}
function $8e5dcecbc0be3c0e$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $8e5dcecbc0be3c0e$var$dontAutoEvaluateFunctions(()=>{
            return $8e5dcecbc0be3c0e$var$evaluate(el, binding.expression);
        });
    }
    return $8e5dcecbc0be3c0e$var$getAttributeBinding(el, name, fallback);
}
function $8e5dcecbc0be3c0e$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($8e5dcecbc0be3c0e$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $8e5dcecbc0be3c0e$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $8e5dcecbc0be3c0e$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $8e5dcecbc0be3c0e$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let reference = $8e5dcecbc0be3c0e$var$effect(()=>{
        const outer = outerGet();
        const inner = innerGet();
        if (firstRun) {
            innerSet($8e5dcecbc0be3c0e$var$cloneIfObject(outer));
            firstRun = false;
            outerHash = JSON.stringify(outer);
        } else {
            const outerHashLatest = JSON.stringify(outer);
            if (outerHashLatest !== outerHash) {
                innerSet($8e5dcecbc0be3c0e$var$cloneIfObject(outer));
                outerHash = outerHashLatest;
            } else {
                outerSet($8e5dcecbc0be3c0e$var$cloneIfObject(inner));
                outerHash = JSON.stringify(inner);
            }
        }
        JSON.stringify(innerGet());
        JSON.stringify(outerGet());
    });
    return ()=>{
        $8e5dcecbc0be3c0e$var$release(reference);
    };
}
function $8e5dcecbc0be3c0e$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $8e5dcecbc0be3c0e$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($8e5dcecbc0be3c0e$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $8e5dcecbc0be3c0e$var$stores = {};
var $8e5dcecbc0be3c0e$var$isReactive = false;
function $8e5dcecbc0be3c0e$var$store(name, value) {
    if (!$8e5dcecbc0be3c0e$var$isReactive) {
        $8e5dcecbc0be3c0e$var$stores = $8e5dcecbc0be3c0e$var$reactive($8e5dcecbc0be3c0e$var$stores);
        $8e5dcecbc0be3c0e$var$isReactive = true;
    }
    if (value === void 0) return $8e5dcecbc0be3c0e$var$stores[name];
    $8e5dcecbc0be3c0e$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $8e5dcecbc0be3c0e$var$stores[name].init();
    $8e5dcecbc0be3c0e$var$initInterceptors2($8e5dcecbc0be3c0e$var$stores[name]);
}
function $8e5dcecbc0be3c0e$var$getStores() {
    return $8e5dcecbc0be3c0e$var$stores;
}
// packages/alpinejs/src/binds.js
var $8e5dcecbc0be3c0e$var$binds = {};
function $8e5dcecbc0be3c0e$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $8e5dcecbc0be3c0e$var$applyBindingsObject(name, getBindings());
    else $8e5dcecbc0be3c0e$var$binds[name] = getBindings;
    return ()=>{};
}
function $8e5dcecbc0be3c0e$var$injectBindingProviders(obj) {
    Object.entries($8e5dcecbc0be3c0e$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $8e5dcecbc0be3c0e$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $8e5dcecbc0be3c0e$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $8e5dcecbc0be3c0e$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $8e5dcecbc0be3c0e$var$datas = {};
function $8e5dcecbc0be3c0e$var$data(name, callback) {
    $8e5dcecbc0be3c0e$var$datas[name] = callback;
}
function $8e5dcecbc0be3c0e$var$injectDataProviders(obj, context) {
    Object.entries($8e5dcecbc0be3c0e$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $8e5dcecbc0be3c0e$var$Alpine = {
    get reactive () {
        return $8e5dcecbc0be3c0e$var$reactive;
    },
    get release () {
        return $8e5dcecbc0be3c0e$var$release;
    },
    get effect () {
        return $8e5dcecbc0be3c0e$var$effect;
    },
    get raw () {
        return $8e5dcecbc0be3c0e$var$raw;
    },
    version: "3.13.3",
    flushAndStopDeferringMutations: $8e5dcecbc0be3c0e$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $8e5dcecbc0be3c0e$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $8e5dcecbc0be3c0e$var$disableEffectScheduling,
    startObservingMutations: $8e5dcecbc0be3c0e$var$startObservingMutations,
    stopObservingMutations: $8e5dcecbc0be3c0e$var$stopObservingMutations,
    setReactivityEngine: $8e5dcecbc0be3c0e$var$setReactivityEngine,
    onAttributeRemoved: $8e5dcecbc0be3c0e$var$onAttributeRemoved,
    onAttributesAdded: $8e5dcecbc0be3c0e$var$onAttributesAdded,
    closestDataStack: $8e5dcecbc0be3c0e$var$closestDataStack,
    skipDuringClone: $8e5dcecbc0be3c0e$var$skipDuringClone,
    onlyDuringClone: $8e5dcecbc0be3c0e$var$onlyDuringClone,
    addRootSelector: $8e5dcecbc0be3c0e$var$addRootSelector,
    addInitSelector: $8e5dcecbc0be3c0e$var$addInitSelector,
    interceptClone: $8e5dcecbc0be3c0e$var$interceptClone,
    addScopeToNode: $8e5dcecbc0be3c0e$var$addScopeToNode,
    deferMutations: $8e5dcecbc0be3c0e$var$deferMutations,
    mapAttributes: $8e5dcecbc0be3c0e$var$mapAttributes,
    evaluateLater: $8e5dcecbc0be3c0e$var$evaluateLater,
    interceptInit: $8e5dcecbc0be3c0e$var$interceptInit,
    setEvaluator: $8e5dcecbc0be3c0e$var$setEvaluator,
    mergeProxies: $8e5dcecbc0be3c0e$var$mergeProxies,
    extractProp: $8e5dcecbc0be3c0e$var$extractProp,
    findClosest: $8e5dcecbc0be3c0e$var$findClosest,
    onElRemoved: $8e5dcecbc0be3c0e$var$onElRemoved,
    closestRoot: $8e5dcecbc0be3c0e$var$closestRoot,
    destroyTree: $8e5dcecbc0be3c0e$var$destroyTree,
    interceptor: $8e5dcecbc0be3c0e$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $8e5dcecbc0be3c0e$var$transition,
    setStyles: // INTERNAL
    $8e5dcecbc0be3c0e$var$setStyles,
    mutateDom: // INTERNAL
    $8e5dcecbc0be3c0e$var$mutateDom,
    directive: $8e5dcecbc0be3c0e$var$directive,
    entangle: $8e5dcecbc0be3c0e$var$entangle,
    throttle: $8e5dcecbc0be3c0e$var$throttle,
    debounce: $8e5dcecbc0be3c0e$var$debounce,
    evaluate: $8e5dcecbc0be3c0e$var$evaluate,
    initTree: $8e5dcecbc0be3c0e$var$initTree,
    nextTick: $8e5dcecbc0be3c0e$var$nextTick,
    prefixed: $8e5dcecbc0be3c0e$var$prefix,
    prefix: $8e5dcecbc0be3c0e$var$setPrefix,
    plugin: $8e5dcecbc0be3c0e$var$plugin,
    magic: $8e5dcecbc0be3c0e$var$magic,
    store: $8e5dcecbc0be3c0e$var$store,
    start: $8e5dcecbc0be3c0e$var$start,
    clone: $8e5dcecbc0be3c0e$var$clone,
    cloneNode: // INTERNAL
    $8e5dcecbc0be3c0e$var$cloneNode,
    // INTERNAL
    bound: $8e5dcecbc0be3c0e$var$getBinding,
    $data: $8e5dcecbc0be3c0e$var$scope,
    walk: $8e5dcecbc0be3c0e$var$walk,
    data: $8e5dcecbc0be3c0e$var$data,
    bind: $8e5dcecbc0be3c0e$var$bind2
};
var $8e5dcecbc0be3c0e$var$alpine_default = $8e5dcecbc0be3c0e$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $8e5dcecbc0be3c0e$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $8e5dcecbc0be3c0e$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $8e5dcecbc0be3c0e$var$isBooleanAttr2 = /* @__PURE__ */ $8e5dcecbc0be3c0e$var$makeMap($8e5dcecbc0be3c0e$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $8e5dcecbc0be3c0e$var$EMPTY_OBJ = Object.freeze({});
var $8e5dcecbc0be3c0e$var$EMPTY_ARR = Object.freeze([]);
var $8e5dcecbc0be3c0e$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $8e5dcecbc0be3c0e$var$hasOwn = (val, key)=>$8e5dcecbc0be3c0e$var$hasOwnProperty.call(val, key);
var $8e5dcecbc0be3c0e$var$isArray = Array.isArray;
var $8e5dcecbc0be3c0e$var$isMap = (val)=>$8e5dcecbc0be3c0e$var$toTypeString(val) === "[object Map]";
var $8e5dcecbc0be3c0e$var$isString = (val)=>typeof val === "string";
var $8e5dcecbc0be3c0e$var$isSymbol = (val)=>typeof val === "symbol";
var $8e5dcecbc0be3c0e$var$isObject = (val)=>val !== null && typeof val === "object";
var $8e5dcecbc0be3c0e$var$objectToString = Object.prototype.toString;
var $8e5dcecbc0be3c0e$var$toTypeString = (value)=>$8e5dcecbc0be3c0e$var$objectToString.call(value);
var $8e5dcecbc0be3c0e$var$toRawType = (value)=>{
    return $8e5dcecbc0be3c0e$var$toTypeString(value).slice(8, -1);
};
var $8e5dcecbc0be3c0e$var$isIntegerKey = (key)=>$8e5dcecbc0be3c0e$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $8e5dcecbc0be3c0e$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $8e5dcecbc0be3c0e$var$camelizeRE = /-(\w)/g;
var $8e5dcecbc0be3c0e$var$camelize = $8e5dcecbc0be3c0e$var$cacheStringFunction((str)=>{
    return str.replace($8e5dcecbc0be3c0e$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $8e5dcecbc0be3c0e$var$hyphenateRE = /\B([A-Z])/g;
var $8e5dcecbc0be3c0e$var$hyphenate = $8e5dcecbc0be3c0e$var$cacheStringFunction((str)=>str.replace($8e5dcecbc0be3c0e$var$hyphenateRE, "-$1").toLowerCase());
var $8e5dcecbc0be3c0e$var$capitalize = $8e5dcecbc0be3c0e$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $8e5dcecbc0be3c0e$var$toHandlerKey = $8e5dcecbc0be3c0e$var$cacheStringFunction((str)=>str ? `on${$8e5dcecbc0be3c0e$var$capitalize(str)}` : ``);
var $8e5dcecbc0be3c0e$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $8e5dcecbc0be3c0e$var$targetMap = /* @__PURE__ */ new WeakMap();
var $8e5dcecbc0be3c0e$var$effectStack = [];
var $8e5dcecbc0be3c0e$var$activeEffect;
var $8e5dcecbc0be3c0e$var$ITERATE_KEY = Symbol("iterate");
var $8e5dcecbc0be3c0e$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $8e5dcecbc0be3c0e$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $8e5dcecbc0be3c0e$var$effect2(fn, options = $8e5dcecbc0be3c0e$var$EMPTY_OBJ) {
    if ($8e5dcecbc0be3c0e$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $8e5dcecbc0be3c0e$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $8e5dcecbc0be3c0e$var$stop(effect3) {
    if (effect3.active) {
        $8e5dcecbc0be3c0e$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $8e5dcecbc0be3c0e$var$uid = 0;
function $8e5dcecbc0be3c0e$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$8e5dcecbc0be3c0e$var$effectStack.includes(effect3)) {
            $8e5dcecbc0be3c0e$var$cleanup(effect3);
            try {
                $8e5dcecbc0be3c0e$var$enableTracking();
                $8e5dcecbc0be3c0e$var$effectStack.push(effect3);
                $8e5dcecbc0be3c0e$var$activeEffect = effect3;
                return fn();
            } finally{
                $8e5dcecbc0be3c0e$var$effectStack.pop();
                $8e5dcecbc0be3c0e$var$resetTracking();
                $8e5dcecbc0be3c0e$var$activeEffect = $8e5dcecbc0be3c0e$var$effectStack[$8e5dcecbc0be3c0e$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $8e5dcecbc0be3c0e$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $8e5dcecbc0be3c0e$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $8e5dcecbc0be3c0e$var$shouldTrack = true;
var $8e5dcecbc0be3c0e$var$trackStack = [];
function $8e5dcecbc0be3c0e$var$pauseTracking() {
    $8e5dcecbc0be3c0e$var$trackStack.push($8e5dcecbc0be3c0e$var$shouldTrack);
    $8e5dcecbc0be3c0e$var$shouldTrack = false;
}
function $8e5dcecbc0be3c0e$var$enableTracking() {
    $8e5dcecbc0be3c0e$var$trackStack.push($8e5dcecbc0be3c0e$var$shouldTrack);
    $8e5dcecbc0be3c0e$var$shouldTrack = true;
}
function $8e5dcecbc0be3c0e$var$resetTracking() {
    const last = $8e5dcecbc0be3c0e$var$trackStack.pop();
    $8e5dcecbc0be3c0e$var$shouldTrack = last === void 0 ? true : last;
}
function $8e5dcecbc0be3c0e$var$track(target, type, key) {
    if (!$8e5dcecbc0be3c0e$var$shouldTrack || $8e5dcecbc0be3c0e$var$activeEffect === void 0) return;
    let depsMap = $8e5dcecbc0be3c0e$var$targetMap.get(target);
    if (!depsMap) $8e5dcecbc0be3c0e$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($8e5dcecbc0be3c0e$var$activeEffect)) {
        dep.add($8e5dcecbc0be3c0e$var$activeEffect);
        $8e5dcecbc0be3c0e$var$activeEffect.deps.push(dep);
        if ($8e5dcecbc0be3c0e$var$activeEffect.options.onTrack) $8e5dcecbc0be3c0e$var$activeEffect.options.onTrack({
            effect: $8e5dcecbc0be3c0e$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $8e5dcecbc0be3c0e$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $8e5dcecbc0be3c0e$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $8e5dcecbc0be3c0e$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $8e5dcecbc0be3c0e$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$8e5dcecbc0be3c0e$var$isArray(target)) {
                    add2(depsMap.get($8e5dcecbc0be3c0e$var$ITERATE_KEY));
                    if ($8e5dcecbc0be3c0e$var$isMap(target)) add2(depsMap.get($8e5dcecbc0be3c0e$var$MAP_KEY_ITERATE_KEY));
                } else if ($8e5dcecbc0be3c0e$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$8e5dcecbc0be3c0e$var$isArray(target)) {
                    add2(depsMap.get($8e5dcecbc0be3c0e$var$ITERATE_KEY));
                    if ($8e5dcecbc0be3c0e$var$isMap(target)) add2(depsMap.get($8e5dcecbc0be3c0e$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($8e5dcecbc0be3c0e$var$isMap(target)) add2(depsMap.get($8e5dcecbc0be3c0e$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $8e5dcecbc0be3c0e$var$isNonTrackableKeys = /* @__PURE__ */ $8e5dcecbc0be3c0e$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $8e5dcecbc0be3c0e$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($8e5dcecbc0be3c0e$var$isSymbol));
var $8e5dcecbc0be3c0e$var$get2 = /* @__PURE__ */ $8e5dcecbc0be3c0e$var$createGetter();
var $8e5dcecbc0be3c0e$var$readonlyGet = /* @__PURE__ */ $8e5dcecbc0be3c0e$var$createGetter(true);
var $8e5dcecbc0be3c0e$var$arrayInstrumentations = /* @__PURE__ */ $8e5dcecbc0be3c0e$var$createArrayInstrumentations();
function $8e5dcecbc0be3c0e$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $8e5dcecbc0be3c0e$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$8e5dcecbc0be3c0e$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($8e5dcecbc0be3c0e$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $8e5dcecbc0be3c0e$var$pauseTracking();
            const res = $8e5dcecbc0be3c0e$var$toRaw(this)[key].apply(this, args);
            $8e5dcecbc0be3c0e$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $8e5dcecbc0be3c0e$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $8e5dcecbc0be3c0e$var$shallowReadonlyMap : $8e5dcecbc0be3c0e$var$readonlyMap : shallow ? $8e5dcecbc0be3c0e$var$shallowReactiveMap : $8e5dcecbc0be3c0e$var$reactiveMap).get(target)) return target;
        const targetIsArray = $8e5dcecbc0be3c0e$var$isArray(target);
        if (!isReadonly && targetIsArray && $8e5dcecbc0be3c0e$var$hasOwn($8e5dcecbc0be3c0e$var$arrayInstrumentations, key)) return Reflect.get($8e5dcecbc0be3c0e$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($8e5dcecbc0be3c0e$var$isSymbol(key) ? $8e5dcecbc0be3c0e$var$builtInSymbols.has(key) : $8e5dcecbc0be3c0e$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $8e5dcecbc0be3c0e$var$track(target, "get", key);
        if (shallow) return res;
        if ($8e5dcecbc0be3c0e$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$8e5dcecbc0be3c0e$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($8e5dcecbc0be3c0e$var$isObject(res)) return isReadonly ? $8e5dcecbc0be3c0e$var$readonly(res) : $8e5dcecbc0be3c0e$var$reactive2(res);
        return res;
    };
}
var $8e5dcecbc0be3c0e$var$set2 = /* @__PURE__ */ $8e5dcecbc0be3c0e$var$createSetter();
function $8e5dcecbc0be3c0e$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $8e5dcecbc0be3c0e$var$toRaw(value);
            oldValue = $8e5dcecbc0be3c0e$var$toRaw(oldValue);
            if (!$8e5dcecbc0be3c0e$var$isArray(target) && $8e5dcecbc0be3c0e$var$isRef(oldValue) && !$8e5dcecbc0be3c0e$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $8e5dcecbc0be3c0e$var$isArray(target) && $8e5dcecbc0be3c0e$var$isIntegerKey(key) ? Number(key) < target.length : $8e5dcecbc0be3c0e$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $8e5dcecbc0be3c0e$var$toRaw(receiver)) {
            if (!hadKey) $8e5dcecbc0be3c0e$var$trigger(target, "add", key, value);
            else if ($8e5dcecbc0be3c0e$var$hasChanged(value, oldValue)) $8e5dcecbc0be3c0e$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $8e5dcecbc0be3c0e$var$deleteProperty(target, key) {
    const hadKey = $8e5dcecbc0be3c0e$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $8e5dcecbc0be3c0e$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $8e5dcecbc0be3c0e$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$8e5dcecbc0be3c0e$var$isSymbol(key) || !$8e5dcecbc0be3c0e$var$builtInSymbols.has(key)) $8e5dcecbc0be3c0e$var$track(target, "has", key);
    return result;
}
function $8e5dcecbc0be3c0e$var$ownKeys(target) {
    $8e5dcecbc0be3c0e$var$track(target, "iterate", $8e5dcecbc0be3c0e$var$isArray(target) ? "length" : $8e5dcecbc0be3c0e$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $8e5dcecbc0be3c0e$var$mutableHandlers = {
    get: $8e5dcecbc0be3c0e$var$get2,
    set: $8e5dcecbc0be3c0e$var$set2,
    deleteProperty: $8e5dcecbc0be3c0e$var$deleteProperty,
    has: $8e5dcecbc0be3c0e$var$has,
    ownKeys: $8e5dcecbc0be3c0e$var$ownKeys
};
var $8e5dcecbc0be3c0e$var$readonlyHandlers = {
    get: $8e5dcecbc0be3c0e$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $8e5dcecbc0be3c0e$var$toReactive = (value)=>$8e5dcecbc0be3c0e$var$isObject(value) ? $8e5dcecbc0be3c0e$var$reactive2(value) : value;
var $8e5dcecbc0be3c0e$var$toReadonly = (value)=>$8e5dcecbc0be3c0e$var$isObject(value) ? $8e5dcecbc0be3c0e$var$readonly(value) : value;
var $8e5dcecbc0be3c0e$var$toShallow = (value)=>value;
var $8e5dcecbc0be3c0e$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $8e5dcecbc0be3c0e$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $8e5dcecbc0be3c0e$var$toRaw(target);
    const rawKey = $8e5dcecbc0be3c0e$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $8e5dcecbc0be3c0e$var$track(rawTarget, "get", key);
    !isReadonly && $8e5dcecbc0be3c0e$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $8e5dcecbc0be3c0e$var$getProto(rawTarget);
    const wrap = isShallow ? $8e5dcecbc0be3c0e$var$toShallow : isReadonly ? $8e5dcecbc0be3c0e$var$toReadonly : $8e5dcecbc0be3c0e$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $8e5dcecbc0be3c0e$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $8e5dcecbc0be3c0e$var$toRaw(target);
    const rawKey = $8e5dcecbc0be3c0e$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $8e5dcecbc0be3c0e$var$track(rawTarget, "has", key);
    !isReadonly && $8e5dcecbc0be3c0e$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $8e5dcecbc0be3c0e$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $8e5dcecbc0be3c0e$var$track($8e5dcecbc0be3c0e$var$toRaw(target), "iterate", $8e5dcecbc0be3c0e$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $8e5dcecbc0be3c0e$var$add(value) {
    value = $8e5dcecbc0be3c0e$var$toRaw(value);
    const target = $8e5dcecbc0be3c0e$var$toRaw(this);
    const proto = $8e5dcecbc0be3c0e$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $8e5dcecbc0be3c0e$var$trigger(target, "add", value, value);
    }
    return this;
}
function $8e5dcecbc0be3c0e$var$set$1(key, value) {
    value = $8e5dcecbc0be3c0e$var$toRaw(value);
    const target = $8e5dcecbc0be3c0e$var$toRaw(this);
    const { has: has2, get: get3 } = $8e5dcecbc0be3c0e$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $8e5dcecbc0be3c0e$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $8e5dcecbc0be3c0e$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $8e5dcecbc0be3c0e$var$trigger(target, "add", key, value);
    else if ($8e5dcecbc0be3c0e$var$hasChanged(value, oldValue)) $8e5dcecbc0be3c0e$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $8e5dcecbc0be3c0e$var$deleteEntry(key) {
    const target = $8e5dcecbc0be3c0e$var$toRaw(this);
    const { has: has2, get: get3 } = $8e5dcecbc0be3c0e$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $8e5dcecbc0be3c0e$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $8e5dcecbc0be3c0e$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $8e5dcecbc0be3c0e$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $8e5dcecbc0be3c0e$var$clear() {
    const target = $8e5dcecbc0be3c0e$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $8e5dcecbc0be3c0e$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $8e5dcecbc0be3c0e$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $8e5dcecbc0be3c0e$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $8e5dcecbc0be3c0e$var$toRaw(target);
        const wrap = isShallow ? $8e5dcecbc0be3c0e$var$toShallow : isReadonly ? $8e5dcecbc0be3c0e$var$toReadonly : $8e5dcecbc0be3c0e$var$toReactive;
        !isReadonly && $8e5dcecbc0be3c0e$var$track(rawTarget, "iterate", $8e5dcecbc0be3c0e$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $8e5dcecbc0be3c0e$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $8e5dcecbc0be3c0e$var$toRaw(target);
        const targetIsMap = $8e5dcecbc0be3c0e$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $8e5dcecbc0be3c0e$var$toShallow : isReadonly ? $8e5dcecbc0be3c0e$var$toReadonly : $8e5dcecbc0be3c0e$var$toReactive;
        !isReadonly && $8e5dcecbc0be3c0e$var$track(rawTarget, "iterate", isKeyOnly ? $8e5dcecbc0be3c0e$var$MAP_KEY_ITERATE_KEY : $8e5dcecbc0be3c0e$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $8e5dcecbc0be3c0e$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$8e5dcecbc0be3c0e$var$capitalize(type)} operation ${key}failed: target is readonly.`, $8e5dcecbc0be3c0e$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $8e5dcecbc0be3c0e$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $8e5dcecbc0be3c0e$var$get$1(this, key);
        },
        get size () {
            return $8e5dcecbc0be3c0e$var$size(this);
        },
        has: $8e5dcecbc0be3c0e$var$has$1,
        add: $8e5dcecbc0be3c0e$var$add,
        set: $8e5dcecbc0be3c0e$var$set$1,
        delete: $8e5dcecbc0be3c0e$var$deleteEntry,
        clear: $8e5dcecbc0be3c0e$var$clear,
        forEach: $8e5dcecbc0be3c0e$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $8e5dcecbc0be3c0e$var$get$1(this, key, false, true);
        },
        get size () {
            return $8e5dcecbc0be3c0e$var$size(this);
        },
        has: $8e5dcecbc0be3c0e$var$has$1,
        add: $8e5dcecbc0be3c0e$var$add,
        set: $8e5dcecbc0be3c0e$var$set$1,
        delete: $8e5dcecbc0be3c0e$var$deleteEntry,
        clear: $8e5dcecbc0be3c0e$var$clear,
        forEach: $8e5dcecbc0be3c0e$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $8e5dcecbc0be3c0e$var$get$1(this, key, true);
        },
        get size () {
            return $8e5dcecbc0be3c0e$var$size(this, true);
        },
        has (key) {
            return $8e5dcecbc0be3c0e$var$has$1.call(this, key, true);
        },
        add: $8e5dcecbc0be3c0e$var$createReadonlyMethod("add"),
        set: $8e5dcecbc0be3c0e$var$createReadonlyMethod("set"),
        delete: $8e5dcecbc0be3c0e$var$createReadonlyMethod("delete"),
        clear: $8e5dcecbc0be3c0e$var$createReadonlyMethod("clear"),
        forEach: $8e5dcecbc0be3c0e$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $8e5dcecbc0be3c0e$var$get$1(this, key, true, true);
        },
        get size () {
            return $8e5dcecbc0be3c0e$var$size(this, true);
        },
        has (key) {
            return $8e5dcecbc0be3c0e$var$has$1.call(this, key, true);
        },
        add: $8e5dcecbc0be3c0e$var$createReadonlyMethod("add"),
        set: $8e5dcecbc0be3c0e$var$createReadonlyMethod("set"),
        delete: $8e5dcecbc0be3c0e$var$createReadonlyMethod("delete"),
        clear: $8e5dcecbc0be3c0e$var$createReadonlyMethod("clear"),
        forEach: $8e5dcecbc0be3c0e$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $8e5dcecbc0be3c0e$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $8e5dcecbc0be3c0e$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $8e5dcecbc0be3c0e$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $8e5dcecbc0be3c0e$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$8e5dcecbc0be3c0e$var$mutableInstrumentations, $8e5dcecbc0be3c0e$var$readonlyInstrumentations, $8e5dcecbc0be3c0e$var$shallowInstrumentations, $8e5dcecbc0be3c0e$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $8e5dcecbc0be3c0e$var$createInstrumentations();
function $8e5dcecbc0be3c0e$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $8e5dcecbc0be3c0e$var$shallowReadonlyInstrumentations : $8e5dcecbc0be3c0e$var$shallowInstrumentations : isReadonly ? $8e5dcecbc0be3c0e$var$readonlyInstrumentations : $8e5dcecbc0be3c0e$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($8e5dcecbc0be3c0e$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $8e5dcecbc0be3c0e$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $8e5dcecbc0be3c0e$var$createInstrumentationGetter(false, false)
};
var $8e5dcecbc0be3c0e$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $8e5dcecbc0be3c0e$var$createInstrumentationGetter(true, false)
};
function $8e5dcecbc0be3c0e$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $8e5dcecbc0be3c0e$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $8e5dcecbc0be3c0e$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $8e5dcecbc0be3c0e$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $8e5dcecbc0be3c0e$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $8e5dcecbc0be3c0e$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $8e5dcecbc0be3c0e$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $8e5dcecbc0be3c0e$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $8e5dcecbc0be3c0e$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $8e5dcecbc0be3c0e$var$targetTypeMap($8e5dcecbc0be3c0e$var$toRawType(value));
}
function $8e5dcecbc0be3c0e$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $8e5dcecbc0be3c0e$var$createReactiveObject(target, false, $8e5dcecbc0be3c0e$var$mutableHandlers, $8e5dcecbc0be3c0e$var$mutableCollectionHandlers, $8e5dcecbc0be3c0e$var$reactiveMap);
}
function $8e5dcecbc0be3c0e$var$readonly(target) {
    return $8e5dcecbc0be3c0e$var$createReactiveObject(target, true, $8e5dcecbc0be3c0e$var$readonlyHandlers, $8e5dcecbc0be3c0e$var$readonlyCollectionHandlers, $8e5dcecbc0be3c0e$var$readonlyMap);
}
function $8e5dcecbc0be3c0e$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$8e5dcecbc0be3c0e$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $8e5dcecbc0be3c0e$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $8e5dcecbc0be3c0e$var$toRaw(observed) {
    return observed && $8e5dcecbc0be3c0e$var$toRaw(observed["__v_raw"]) || observed;
}
function $8e5dcecbc0be3c0e$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$8e5dcecbc0be3c0e$var$magic("nextTick", ()=>$8e5dcecbc0be3c0e$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$8e5dcecbc0be3c0e$var$magic("dispatch", (el)=>$8e5dcecbc0be3c0e$var$dispatch.bind($8e5dcecbc0be3c0e$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$8e5dcecbc0be3c0e$var$magic("watch", (el, { evaluateLater: evaluateLater2, effect: effect3 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let firstTime = true;
        let oldValue;
        let effectReference = effect3(()=>evaluate2((value)=>{
                JSON.stringify(value);
                if (!firstTime) queueMicrotask(()=>{
                    callback(value, oldValue);
                    oldValue = value;
                });
                else oldValue = value;
                firstTime = false;
            }));
        el._x_effects.delete(effectReference);
    });
// packages/alpinejs/src/magics/$store.js
$8e5dcecbc0be3c0e$var$magic("store", $8e5dcecbc0be3c0e$var$getStores);
// packages/alpinejs/src/magics/$data.js
$8e5dcecbc0be3c0e$var$magic("data", (el)=>$8e5dcecbc0be3c0e$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$8e5dcecbc0be3c0e$var$magic("root", (el)=>$8e5dcecbc0be3c0e$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$8e5dcecbc0be3c0e$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $8e5dcecbc0be3c0e$var$mergeProxies($8e5dcecbc0be3c0e$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $8e5dcecbc0be3c0e$var$getArrayOfRefObject(el) {
    let refObjects = [];
    let currentEl = el;
    while(currentEl){
        if (currentEl._x_refs) refObjects.push(currentEl._x_refs);
        currentEl = currentEl.parentNode;
    }
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $8e5dcecbc0be3c0e$var$globalIdMemo = {};
function $8e5dcecbc0be3c0e$var$findAndIncrementId(name) {
    if (!$8e5dcecbc0be3c0e$var$globalIdMemo[name]) $8e5dcecbc0be3c0e$var$globalIdMemo[name] = 0;
    return ++$8e5dcecbc0be3c0e$var$globalIdMemo[name];
}
function $8e5dcecbc0be3c0e$var$closestIdRoot(el, name) {
    return $8e5dcecbc0be3c0e$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $8e5dcecbc0be3c0e$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $8e5dcecbc0be3c0e$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$8e5dcecbc0be3c0e$var$magic("id", (el)=>(name, key = null)=>{
        let root = $8e5dcecbc0be3c0e$var$closestIdRoot(el, name);
        let id = root ? root._x_ids[name] : $8e5dcecbc0be3c0e$var$findAndIncrementId(name);
        return key ? `${name}-${id}-${key}` : `${name}-${id}`;
    });
// packages/alpinejs/src/magics/$el.js
$8e5dcecbc0be3c0e$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$8e5dcecbc0be3c0e$var$warnMissingPluginMagic("Focus", "focus", "focus");
$8e5dcecbc0be3c0e$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $8e5dcecbc0be3c0e$var$warnMissingPluginMagic(name, magicName, slug) {
    $8e5dcecbc0be3c0e$var$magic(magicName, (el)=>$8e5dcecbc0be3c0e$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$8e5dcecbc0be3c0e$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $8e5dcecbc0be3c0e$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$8e5dcecbc0be3c0e$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $8e5dcecbc0be3c0e$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $8e5dcecbc0be3c0e$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $8e5dcecbc0be3c0e$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $8e5dcecbc0be3c0e$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $8e5dcecbc0be3c0e$var$initTree(clone2);
        clone2._x_ignore = true;
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $8e5dcecbc0be3c0e$var$getTarget(expression);
        $8e5dcecbc0be3c0e$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>clone2.remove());
});
var $8e5dcecbc0be3c0e$var$teleportContainerDuringClone = document.createElement("div");
function $8e5dcecbc0be3c0e$var$getTarget(expression) {
    let target = $8e5dcecbc0be3c0e$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $8e5dcecbc0be3c0e$var$teleportContainerDuringClone;
    })();
    if (!target) $8e5dcecbc0be3c0e$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $8e5dcecbc0be3c0e$var$handler = ()=>{};
$8e5dcecbc0be3c0e$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$8e5dcecbc0be3c0e$var$directive("ignore", $8e5dcecbc0be3c0e$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$8e5dcecbc0be3c0e$var$directive("effect", $8e5dcecbc0be3c0e$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($8e5dcecbc0be3c0e$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $8e5dcecbc0be3c0e$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $8e5dcecbc0be3c0e$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $8e5dcecbc0be3c0e$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $8e5dcecbc0be3c0e$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $8e5dcecbc0be3c0e$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $8e5dcecbc0be3c0e$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $8e5dcecbc0be3c0e$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    handler4 = wrapHandler(handler4, (next, e)=>{
        if ($8e5dcecbc0be3c0e$var$isKeyEvent(event)) {
            if ($8e5dcecbc0be3c0e$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        }
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $8e5dcecbc0be3c0e$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $8e5dcecbc0be3c0e$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $8e5dcecbc0be3c0e$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $8e5dcecbc0be3c0e$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $8e5dcecbc0be3c0e$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $8e5dcecbc0be3c0e$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $8e5dcecbc0be3c0e$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $8e5dcecbc0be3c0e$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $8e5dcecbc0be3c0e$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($8e5dcecbc0be3c0e$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $8e5dcecbc0be3c0e$var$keyToModifiers(key) {
    if (!key) return [];
    key = $8e5dcecbc0be3c0e$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$8e5dcecbc0be3c0e$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $8e5dcecbc0be3c0e$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $8e5dcecbc0be3c0e$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $8e5dcecbc0be3c0e$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $8e5dcecbc0be3c0e$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($8e5dcecbc0be3c0e$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $8e5dcecbc0be3c0e$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $8e5dcecbc0be3c0e$var$isCloning ? ()=>{} : $8e5dcecbc0be3c0e$var$on(el, event, modifiers, (e)=>{
        setValue($8e5dcecbc0be3c0e$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            null,
            ""
        ].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue())) el.dispatchEvent(new Event(event, {}));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $8e5dcecbc0be3c0e$var$on(el.form, "reset", [], (e)=>{
            $8e5dcecbc0be3c0e$var$nextTick(()=>el._x_model && el._x_model.set(el.value));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $8e5dcecbc0be3c0e$var$mutateDom(()=>$8e5dcecbc0be3c0e$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $8e5dcecbc0be3c0e$var$getInputValue(el, modifiers, event, currentValue) {
    return $8e5dcecbc0be3c0e$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $8e5dcecbc0be3c0e$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $8e5dcecbc0be3c0e$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$8e5dcecbc0be3c0e$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $8e5dcecbc0be3c0e$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $8e5dcecbc0be3c0e$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            if (modifiers.includes("number")) return $8e5dcecbc0be3c0e$var$safeParseNumber(event.target.value);
            else if (modifiers.includes("boolean")) return $8e5dcecbc0be3c0e$var$safeParseBoolean(event.target.value);
            return modifiers.includes("trim") ? event.target.value.trim() : event.target.value;
        }
    });
}
function $8e5dcecbc0be3c0e$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $8e5dcecbc0be3c0e$var$isNumeric2(number) ? number : rawValue;
}
function $8e5dcecbc0be3c0e$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $8e5dcecbc0be3c0e$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $8e5dcecbc0be3c0e$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$8e5dcecbc0be3c0e$var$directive("cloak", (el)=>queueMicrotask(()=>$8e5dcecbc0be3c0e$var$mutateDom(()=>el.removeAttribute($8e5dcecbc0be3c0e$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$8e5dcecbc0be3c0e$var$addInitSelector(()=>`[${$8e5dcecbc0be3c0e$var$prefix("init")}]`);
$8e5dcecbc0be3c0e$var$directive("init", $8e5dcecbc0be3c0e$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$8e5dcecbc0be3c0e$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $8e5dcecbc0be3c0e$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$8e5dcecbc0be3c0e$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $8e5dcecbc0be3c0e$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $8e5dcecbc0be3c0e$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$8e5dcecbc0be3c0e$var$mapAttributes($8e5dcecbc0be3c0e$var$startingWith(":", $8e5dcecbc0be3c0e$var$into($8e5dcecbc0be3c0e$var$prefix("bind:"))));
var $8e5dcecbc0be3c0e$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3 })=>{
    if (!value) {
        let bindingProviders = {};
        $8e5dcecbc0be3c0e$var$injectBindingProviders(bindingProviders);
        let getBindings = $8e5dcecbc0be3c0e$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $8e5dcecbc0be3c0e$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $8e5dcecbc0be3c0e$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $8e5dcecbc0be3c0e$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $8e5dcecbc0be3c0e$var$mutateDom(()=>$8e5dcecbc0be3c0e$var$bind(el, value, result, modifiers));
        }));
};
$8e5dcecbc0be3c0e$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$8e5dcecbc0be3c0e$var$directive("bind", $8e5dcecbc0be3c0e$var$handler2);
function $8e5dcecbc0be3c0e$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$8e5dcecbc0be3c0e$var$addRootSelector(()=>`[${$8e5dcecbc0be3c0e$var$prefix("data")}]`);
$8e5dcecbc0be3c0e$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($8e5dcecbc0be3c0e$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $8e5dcecbc0be3c0e$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $8e5dcecbc0be3c0e$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $8e5dcecbc0be3c0e$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $8e5dcecbc0be3c0e$var$injectMagics(data2, el);
    let reactiveData = $8e5dcecbc0be3c0e$var$reactive(data2);
    $8e5dcecbc0be3c0e$var$initInterceptors2(reactiveData);
    let undo = $8e5dcecbc0be3c0e$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $8e5dcecbc0be3c0e$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $8e5dcecbc0be3c0e$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$8e5dcecbc0be3c0e$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $8e5dcecbc0be3c0e$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$8e5dcecbc0be3c0e$var$isCloning) return false;
    if ($8e5dcecbc0be3c0e$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$8e5dcecbc0be3c0e$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $8e5dcecbc0be3c0e$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $8e5dcecbc0be3c0e$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $8e5dcecbc0be3c0e$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $8e5dcecbc0be3c0e$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$8e5dcecbc0be3c0e$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $8e5dcecbc0be3c0e$var$parseForExpression(expression);
    let evaluateItems = $8e5dcecbc0be3c0e$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $8e5dcecbc0be3c0e$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$8e5dcecbc0be3c0e$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $8e5dcecbc0be3c0e$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($8e5dcecbc0be3c0e$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $8e5dcecbc0be3c0e$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>keys.push(value2), {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $8e5dcecbc0be3c0e$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>keys.push(value), {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($8e5dcecbc0be3c0e$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $8e5dcecbc0be3c0e$var$mutateDom(()=>{
                if (!elForSpot) $8e5dcecbc0be3c0e$var$warn(`x-for ":key" is undefined or invalid`, templateEl);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $8e5dcecbc0be3c0e$var$reactive(scope2);
            $8e5dcecbc0be3c0e$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $8e5dcecbc0be3c0e$var$mutateDom(()=>{
                lastEl.after(clone2);
                $8e5dcecbc0be3c0e$var$initTree(clone2);
            });
            if (typeof key === "object") $8e5dcecbc0be3c0e$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $8e5dcecbc0be3c0e$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $8e5dcecbc0be3c0e$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $8e5dcecbc0be3c0e$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $8e5dcecbc0be3c0e$var$handler3() {}
$8e5dcecbc0be3c0e$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $8e5dcecbc0be3c0e$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$8e5dcecbc0be3c0e$var$directive("ref", $8e5dcecbc0be3c0e$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$8e5dcecbc0be3c0e$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $8e5dcecbc0be3c0e$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $8e5dcecbc0be3c0e$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $8e5dcecbc0be3c0e$var$addScopeToNode(clone2, {}, el);
        $8e5dcecbc0be3c0e$var$mutateDom(()=>{
            el.after(clone2);
            $8e5dcecbc0be3c0e$var$initTree(clone2);
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $8e5dcecbc0be3c0e$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($8e5dcecbc0be3c0e$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$8e5dcecbc0be3c0e$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$8e5dcecbc0be3c0e$var$setIdRoot(el, name));
});
// packages/alpinejs/src/directives/x-on.js
$8e5dcecbc0be3c0e$var$mapAttributes($8e5dcecbc0be3c0e$var$startingWith("@", $8e5dcecbc0be3c0e$var$into($8e5dcecbc0be3c0e$var$prefix("on:"))));
$8e5dcecbc0be3c0e$var$directive("on", $8e5dcecbc0be3c0e$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $8e5dcecbc0be3c0e$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $8e5dcecbc0be3c0e$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$8e5dcecbc0be3c0e$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$8e5dcecbc0be3c0e$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$8e5dcecbc0be3c0e$var$warnMissingPluginDirective("Focus", "trap", "focus");
$8e5dcecbc0be3c0e$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $8e5dcecbc0be3c0e$var$warnMissingPluginDirective(name, directiveName, slug) {
    $8e5dcecbc0be3c0e$var$directive(directiveName, (el)=>$8e5dcecbc0be3c0e$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$8e5dcecbc0be3c0e$var$alpine_default.setEvaluator($8e5dcecbc0be3c0e$var$normalEvaluator);
$8e5dcecbc0be3c0e$var$alpine_default.setReactivityEngine({
    reactive: $8e5dcecbc0be3c0e$var$reactive2,
    effect: $8e5dcecbc0be3c0e$var$effect2,
    release: $8e5dcecbc0be3c0e$var$stop,
    raw: $8e5dcecbc0be3c0e$var$toRaw
});
var $8e5dcecbc0be3c0e$var$src_default = $8e5dcecbc0be3c0e$var$alpine_default;
// packages/alpinejs/builds/module.js
var $8e5dcecbc0be3c0e$export$2e2bcd8739ae039 = $8e5dcecbc0be3c0e$var$src_default;


window.Alpine = (0, $8e5dcecbc0be3c0e$export$2e2bcd8739ae039);
(0, $8e5dcecbc0be3c0e$export$2e2bcd8739ae039).start();


//# sourceMappingURL=404.cd4bf0ef.js.map
